const CompleteOrderDetails = ({ order, formatDate, formatCurrency }) => (
    <div className="mt-8 p-5 border rounded-lg shadow-md bg-gray-50 overflow-x-scroll">
      <h3 className="text-xl font-semibold text-secondary mb-4">Complete Order Information</h3>
      <div className="space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-2 gap:4 md:gap-20">
          <div>
            <p className="font-medium text-gray-700">Order ID:</p><p className="mb-2">{order._id}</p>
            <p className="font-medium text-gray-700">Transaction ID:</p><p className="mb-2">{order.transactionId}</p>
            <p className="font-medium text-gray-700">Status:</p><p className="mb-2">{order.status}</p>
            <p className="font-medium text-gray-700">Total Amount:</p><p className="mb-2">${formatCurrency(order.totalAmount)}</p>
          </div>
          <div>
            <p className="font-medium text-gray-700">Created At:</p><p className="mb-2">{formatDate(order.createdAt)}</p>
            <p className="font-medium text-gray-700">Last Updated:</p><p className="mb-2">{formatDate(order.updatedAt)}</p>
            {/* <p className="font-medium text-gray-700">Address ID:</p><p className="mb-2">{order.addressId}</p> */}
          </div>
        </div>
      </div>
    </div>
  );
  export default CompleteOrderDetails